export default () => {
    return {
        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.element
                };
            }

            gsap.fromTo(
                this.$refs.element,
                { opacity: 0 },
                {
                    opacity: 1,
                    duration: 0.5,
                    delay: delay,
                    ease: 'quad.out',
                    scrollTrigger: stSettings
                }
            );
        }
    };
};
